import { Link } from "react-router-dom";
import { useFormik } from "formik";
import AuthLayout from "../../Layouts/AuthLayout";
import { useMutation } from "react-query";
import { postRequest } from "../../utils/axios";
import { ForgotPasswordValidator } from "../../utils/validators/auth";

//Components
import { Form, Button } from "react-bootstrap";
import Spinner from "react-spinner-material";
import Swal from "sweetalert2";

//styles
import styles from "./styles/login.module.scss";
import "sweetalert2/src/sweetalert2.scss";

const ForgotPassword = () => {
  const { mutate, isLoading } = useMutation(postRequest, {
    onSuccess(response) {
      // console.log(response);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Reset code sent to your email!",
        showConfirmButton: true,
      });
    },
    onError(error) {
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response?.data?.message || "Something went wrong",
        showCancelButton: true,
        showConfirmButton: false,
      });
    },
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: ForgotPasswordValidator(),
    onSubmit: (values) => {
      // console.log(values);
      mutate({
        url: "da/admin/forgot-password",
        data: values,
      });
    },
  });

  return (
    <AuthLayout>
      <div className={styles.formBox}>
        <h2 className={`${styles.header} mb-10`}>Forgot Password</h2>
        <Form name="forgotPasswordForm" onSubmit={formik.handleSubmit}>
          <Form.Group className={` mb-4`}>
            <Form.Control
              placeholder="Enter email"
              style={
                formik.touched.email &&
                formik.errors.email && { border: "1px solid red" }
              }
              id="email"
              type="email"
              className={`${styles.input} shadow-none`}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <p className="text-sm mt-1" style={{ color: "red" }}>
                <b>{formik.errors.email}</b>
              </p>
            ) : null}
          </Form.Group>

          <Button type="submit" size="lg" className={`${styles.btn} mt-3`}>
            {isLoading ? (
              <Spinner
                className="mx-auto"
                color="white"
                radius={28}
                stroke={2}
              />
            ) : (
              "Send Reset Code"
            )}
          </Button>
          <div className="text-center text-sm mt-3">
            <b>
              Remember your password?{" "}
              <Link to="/" style={{ textDecoration: "none" }}>
                Login
              </Link>
            </b>
          </div>
        </Form>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
